import React from 'react';
import { TextField } from '@mui/material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface CheckpointTextProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: string) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointText: React.FC<CheckpointTextProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  return (
    <TextField
      size="small"
      fullWidth
      label={checkpoint.checkpointName}
      placeholder={`Enter ${checkpoint.checkpointName}`}
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={isReadOnly}
      error={Boolean(error)}
      helperText={error}
      required={checkpoint.required}
      multiline={checkpoint.allowMultiple}
      minRows={checkpoint.allowMultiple ? 2 : 1}
    />
  );
};
